const dayjs = require('dayjs')

export const getDate = (date: string) => {
    const parsed = dayjs(date);
    if (!parsed.isValid()) {
        return null
    }
    return dayjs(
        dayjs(date)
            .toDate()
            .toLocaleString("en-US", { timeZone: "Asia/Bangkok" })
    ).toDate();
}
